import { OrganizationPublicApi } from 'woofwoof-api-public';
import client, { publicAxiosBaseUrl } from './client';

export const publicOrganizationApi = new OrganizationPublicApi(
  {
    basePath: publicAxiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
